export default {"src":"/_next/static/media/applications-small.f2a3d5e0.svg","height":1000,"width":1200,"blurWidth":0,"blurHeight":0};